import { connect } from 'react-redux';
import { fetchFiles, uploadFile } from '../../../redux/actions/deal-files-actions';
import LeaseCompAbstractionTab from './LeaseCompAbstractionTab';

const mapStateToProps = state => ({
  deal: state.deal.deal,
  dealFiles: state.dealFiles.files,
  abstractionLeaseFile: state.dealFiles.abstractionLeaseFile,
});

const mapDispatchToProps = {
  fetchFiles,
  uploadFile,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeaseCompAbstractionTab);
